module.exports = __webpack_public_path__ + "static/media/forward-arrow.1cc2a66f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forward-arrow.svg
// module id = 376
// module chunks = 0